<template>
  <div class="order-container"> 
    <!-- 搜索区域 -->
    <div class="search-section">
      <van-search 
        v-model="searchKeyword" 
        placeholder="请输入维修单号" 
        show-action
        @search="handleSearch"
        @cancel="handleCancel"
        class="search-box"
      />
    </div>

    <!-- 标签页 -->
    <div class="tab-section">
      <van-tabs 
        v-model="activeTab" 
        @click="handleTabChange"
        animated
        swipeable
      >
        <van-tab 
          v-for="tab in tabs" 
          :key="tab.id"
          :title="tab.title"
        >
          <div class="tab-content">
            <order-list 
              :soList="soList"
              :loading="loading"
              :errorMessage="errorMessage"
              :showActions="getShowActions(tab.id)"
              @survey="handleSurvey"
              @survey-show="handleSurveyShow"
              @retry="handleRetry"
            />
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import { Toast, Loading, Empty, Icon, Button, Tag } from 'vant';

// 订单列表组件 - 使用渲染函数
const OrderList = {
  props: {
    soList: Array,
    loading: Boolean,
    errorMessage: String,
    showActions: Object
  },
  methods: {
    getStatusType(status) {
      const statusMap = {
        '进行中': 'primary',
        '已完成': 'success',
        '待处理': 'warning',
        '已取消': 'danger'
      }
      return statusMap[status] || 'default'
    },
    
    formatDate(dateString) {
      if (!dateString) return '--'
      return dateString
    },
    
    handleSurvey(orderId) {
      this.$emit('survey', orderId)
    },
    
    handleSurveyShow(orderId) {
      this.$emit('survey-show', orderId)
    },
    
    handleRetry() {
      this.$emit('retry')
    }
  },
  render(h) {
    // 加载状态
    if (this.loading) {
      return h('div', { class: 'loading-state' }, [
        h(Loading, { props: { type: 'spinner', size: '24px' } }, ['加载中...'])
      ])
    }

    // 错误信息
    if (this.errorMessage) {
      return h('div', { class: 'message-box' }, [
        h(Icon, { props: { name: 'info' }, class: 'message-icon' }),
        h('span', { class: 'message-text' }, this.errorMessage),
        h(Button, {
          props: { size: 'small', type: 'primary' },
          class: 'retry-btn',
          on: { click: this.handleRetry }
        }, '重试')
      ])
    }

    // 订单列表
    if (this.soList && this.soList.length > 0) {
      return h('div', { class: 'orders-container' }, 
        this.soList.map(item => 
          h('div', { key: item.OrdID, class: 'order-card' }, [
            // 订单头部
            h('div', { class: 'order-header' }, [
              h(Icon, { props: { name: 'orders' }, class: 'order-icon' }),
              h('span', { class: 'order-id' }, item.OrdID),
              h(Tag, {
                props: { 
                  type: this.getStatusType(item.Status_Value) 
                },
                class: 'status-tag'
              }, item.Status_Value)
            ]),
            
            // 订单主体
            h('div', { class: 'order-body' }, [
              h('div', { class: 'order-item' }, [
                h(Icon, { props: { name: 'phone' }, class: 'item-icon' }),
                h('span', { class: 'item-label' }, '型号：'),
                h('span', { class: 'item-value' }, item.model || '--')
              ]),
              h('div', { class: 'order-item' }, [
                h(Icon, { props: { name: 'clock' }, class: 'item-icon' }),
                h('span', { class: 'item-label' }, '日期：'),
                h('span', { class: 'item-value' }, this.formatDate(item.ordtime))
              ])
            ]),

            // 操作按钮
            this.showActions ? h('div', { class: 'order-actions' }, [
              this.showActions.survey && h(Button, {
                props: { size: 'small', type: 'primary' },
                class: 'action-btn',
                on: { click: () => this.handleSurvey(item.idlink) }
              }, [
                h(Icon, { props: { name: 'comment' } }),
                '我要点评'
              ]),
              this.showActions.surveyShow && h(Button, {
                props: { size: 'small', type: 'default' },
                class: 'action-btn',
                on: { click: () => this.handleSurveyShow(item.idlink) }
              }, [
                h(Icon, { props: { name: 'eye' } }),
                '查看我的点评'
              ])
            ].filter(Boolean)) : null
          ])
        )
      )
    }

    // 空状态
    return h('div', { class: 'empty-state' }, [
      h(Empty, {
        props: { description: '暂无工单记录', image: 'search' }
      }, [
        h(Button, {
          props: { round: true, type: 'primary' },
          class: 'retry-btn',
          on: { click: this.handleRetry }
        }, '重新搜索')
      ])
    ])
  }
}

// 常量定义
const API_BASE_URL = 'https://t3.lenovoimage.com/api/Web2/mysolist'
const TABS = [
  { id: 0, title: '进行中', showSurvey: true, showSurveyResult: false },
  { id: 1, title: '待点评', showSurvey: false, showSurveyResult: true },
  { id: 2, title: '全部', showSurvey: false, showSurveyResult: false }
]

export default {
  name: 'SRSO',
  components: { 
    'order-list': OrderList 
  },
  data() {
    return {		
      searchKeyword: '',
      soList: [],
      loading: false,
      errorMessage: '',
      activeTab: 0,
      tabs: TABS
    }
  },	 
  
  mounted() {
    document.title = '工单查询'
    this.fetchOrderList()
  },
  
  methods: {	
    /**
     * 获取订单列表
     */
    async fetchOrderList() {
      this.loading = true
      this.errorMessage = ''
      
      try {
        const response = await Vue.axios.get(API_BASE_URL, {
          headers: {
            'Authorization': localStorage.getItem('access_token') || ''
          },
          params: {
            statusid: this.activeTab,
            keyword: this.searchKeyword
          }
        })
        
        this.handleOrderResponse(response.data)
      } catch (error) {
        this.handleOrderError(error)
      } finally {
        this.loading = false
      }
    },
    
    /**
     * 处理订单响应
     */
    handleOrderResponse(data) {
      if (data.Data && data.Data.length > 0) {
        this.soList = data.Data
        this.errorMessage = `共发现 ${data.Data.length} 条记录`
      } else {
        this.soList = []
        this.errorMessage = '没有找到合适的记录！'
      }
    },
    
    /**
     * 处理订单错误
     */
    handleOrderError(error) {
      console.error('获取订单列表失败:', error)
      this.soList = []
      this.errorMessage = '获取数据失败，请重试'
      
      if (error.response && error.response.status === 401) {
        Toast.fail('登录已过期，请重新登录')
        this.$router.push('/login')
      }
    },
    
    /**
     * 处理搜索
     */
    handleSearch() {
      this.fetchOrderList()
    },
    
    /**
     * 处理取消搜索
     */
    handleCancel() {
      this.searchKeyword = ''
      this.fetchOrderList()
    },
    
    /**
     * 处理标签切换
     */
    handleTabChange() {
      this.fetchOrderList()
    },
    
    /**
     * 获取显示操作按钮配置
     */
    getShowActions(tabId) {
      const tab = this.tabs.find(t => t.id === tabId)
      return tab ? {
        survey: tab.showSurvey,
        surveyShow: tab.showSurveyResult
      } : null
    },
    
    /**
     * 处理点评
     */
    handleSurvey(orderId) {
      if (!orderId) {
        Toast.fail('订单ID不能为空')
        return
      }
      
      this.$router.push({
        path: '/srso/survey',
        query: { 
          id: orderId,
          token: localStorage.getItem('access_token')
        }
      })
    },
    
    /**
     * 处理查看点评
     */
    handleSurveyShow(orderId) {
      if (!orderId) {
        Toast.fail('订单ID不能为空')
        return
      }
      
      this.$router.push({
        path: '/srso/surveyshow',
        query: { 
          id: orderId,
          token: localStorage.getItem('access_token')
        }
      })
    },
    
    /**
     * 处理重试
     */
    handleRetry() {
      this.fetchOrderList()
    }
  }
}
</script>

<style scoped>
.order-container {
  background-color: #f7f8fa;
  min-height: 100vh;
}

.search-section {
  background-color: #ffffff;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.search-box {
  padding: 0;
  border-radius: 8px;
  overflow: hidden;
}

.tab-section {
  background-color: #ffffff;
  margin-top: 8px;
}

.tab-content {
  padding: 16px;
  background-color: #f7f8fa;
  min-height: 60vh;
}

.order-list {
  padding: 0;
}

.loading-state {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
}

.message-box {
  background-color: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.message-icon {
  color: #1890ff;
  margin-right: 8px;
  font-size: 16px;
}

.message-text {
  color: #1890ff;
  font-size: 14px;
  flex: 1;
}

.orders-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.order-card {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease;
}

.order-card:active {
  background-color: #f5f5f5;
  transform: scale(0.98);
}

.order-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f5f5f5;
}

.order-icon {
  color: #1989fa;
  font-size: 16px;
  margin-right: 8px;
}

.order-id {
  font-size: 16px;
  font-weight: bold;
  color: #c7254e;
  margin-right: auto;
}

.status-tag {
  margin-left: 8px;
}

.order-body {
  margin-bottom: 16px;
}

.order-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-size: 14px;
}

.order-item:last-child {
  margin-bottom: 0;
}

.item-icon {
  color: #969799;
  font-size: 14px;
  margin-right: 8px;
  width: 16px;
}

.item-label {
  color: #646566;
  min-width: 50px;
}

.item-value {
  color: #323233;
  font-weight: 500;
}

.order-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.action-btn {
  border-radius: 16px;
  font-size: 12px;
}

.empty-state {
  padding: 40px 20px;
}

.retry-btn {
  margin-top: 16px;
}
</style>